/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Search_PlaceholderInputs */

const en_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search events...`)
};

const fr_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des evenements...`)
};

const de_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchereignisse...`)
};

const it_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca eventi...`)
};

const ru_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск событий...`)
};

const es_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar eventos...`)
};

const zh_cn2_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索事件...`)
};

const ja_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを検索...`)
};

const hi_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज कार्यक्रम...`)
};

const pt_pt2_editor_search_placeholder = /** @type {(inputs: Editor_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar eventos...`)
};

/**
* | output |
* | --- |
* | "Search events..." |
*
* @param {Editor_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_search_placeholder = /** @type {((inputs?: Editor_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_search_placeholder(inputs)
	if (locale === "de") return de_editor_search_placeholder(inputs)
	if (locale === "it") return it_editor_search_placeholder(inputs)
	if (locale === "ru") return ru_editor_search_placeholder(inputs)
	if (locale === "es") return es_editor_search_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_search_placeholder(inputs)
	if (locale === "ja") return ja_editor_search_placeholder(inputs)
	if (locale === "hi") return hi_editor_search_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_search_placeholder(inputs)
	return en_editor_search_placeholder(inputs)
});